import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isValidString } from "../../helper";
import { logout } from "../../redux/actions/auth";
import ProfileImg from "../../Assets/Images/avatar.svg";
import dashboardImg from "../../Assets/Images/dashboardImg.svg";
import accessments from "../../Assets/Images/accessments.svg";
import contact from "../../Assets/Images/contact.svg";
import managements from "../../Assets/Images/management.svg";
import achievements from "../../Assets/Images/achievements.svg";
import organiser from "../../Assets/Images/organiser.svg";
import controls from "../../Assets/Images/controls.svg";
import programs from "../../Assets/Images/programs.svg";
import reportImg from "../../Assets/Images/report-img.svg";
import trainingImg from "../../Assets/Images/training-img.svg";
import logOut from "../../Assets/Images/log-out.svg";
import dice from "../../Assets/Images/Vector.svg";
import menu from "../../Assets/Images/sidebar/Frame.svg";
import logo from "../../Assets/Images/logo.svg";
import tap from "../../Assets/icons/tap.svg";
import "./style.css";

const Sidebar = (props) => {

  const dispatch = useDispatch();

  const user = useSelector(state => state.auth.user);
  const school = useSelector(state => state.common.schoolInfo)

  const handleLogout = () => {
    dispatch(logout())
    localStorage.removeItem("kidex-sd-token")
  }
  return (
    <div className="sidebar">
      <div className="profile">
        <img src={isValidString(user?.profile_photo) ? user?.profile_photo : ProfileImg} alt="profile-pic" />
        <p className={`mb-0 ${props.isActive == "active" ? "d-none" : ""}`}>
          {user?.name}
        </p>
      </div>
      <div className="sidebar-mob">
        <div className="sidebar-header">
          <div className="right-bars" onClick={props.showSidebar}>
            <img src={menu} alt="left-right" />
          </div>
        </div>
        <div className="school-details">
          <img src={isValidString(school?.image) ? school?.image : logo} alt="logo" />
          <div className="text text-center d-block">
            <p className="top-txt mb-0 color-blue fw-bold">{school?.name}</p>
            <p className="mb-0">{school?.city}{(school?.city && school?.state) ?? ","} {school?.state}</p>
          </div>
        </div>
      </div>
      <div className="list-content">
        <li className={props.page === "dashboard" ? "active" : ""}>
          <Link to="/dashboard" className={`${props.isActive == "active" ? "justify-content-centered" : ""}`}>
            <img src={dashboardImg} alt="dashboardImg" />
            <p className={`m-0 ${props.isActive == "active" ? "d-hide" : ""}`}>Dashboard</p>
          </Link>
        </li>
        {/* <li className={props.page === "training" ? "active" : ""}>
          <Link
            to="/training"
            className={`${
              props.isActive == "active" ? "justify-content-centered" : ""
            }`}
          >
            <img src={trainingImg} alt="trainingImg" />
            <p className={`m-0 ${props.isActive == "active" ? "d-hide" : ""}`}>
              Training
            </p>
          </Link>
        </li> */}
        <li className={props.page === "reportCard" ? "active" : ""}>
          <Link to="/report-card" className={`${props.isActive == "active" ? "justify-content-centered" : ""}`}>
            <img src={reportImg} alt="reportImg" />
            <p className={`m-0 ${props.isActive == "active" ? "d-hide" : ""}`}>Report Card</p>
          </Link>
        </li>
        <li className={props.page === "learningPrograms" ? "active" : ""}>
          <Link to="/learning-programs" className={`${props.isActive == "active" ? "justify-content-centered" : ""}`}>
            <img src={programs} alt="programs" />
            <p className={`m-0 ${props.isActive == "active" ? "d-hide" : ""}`}>Learning Programs</p>
          </Link>
        </li>
        <li className={props.page === "management" ? "active" : ""}>
          <Link to="/student-management" className={`${props.isActive == "active" ? "justify-content-centered" : ""}`}>
            <img src={managements} alt="Managements" />
            <p className={`m-0 ${props.isActive == "active" ? "d-hide" : ""}`}>Student Managements</p>
          </Link>
        </li>
        <li className={props.page === "achievements" ? "active" : ""}>
          <Link to="/student-achievements" className={`${props.isActive == "active" ? "justify-content-centered" : ""}`}>
            <img src={achievements} alt="achievements" />
            <p className={`m-0 ${props.isActive == "active" ? "d-hide" : ""}`}>Student achievements</p>
          </Link>
        </li>
        {/* <li className={props.page === "organizer" ? "active" : ""}>
          <Link
            to="/organizer-communications"
            className={`${
              props.isActive == "active" ? "justify-content-centered" : ""
            }`}
          >
            <img src={organiser} alt="organiser" />
            <p className={`m-0 ${props.isActive == "active" ? "d-hide" : ""}`}>
              Organizer Communications
            </p>
          </Link>
        </li>
        <li className={props.page === "accessments" ? "active" : ""}>
          <Link
            to="/assessments"
            className={`${
              props.isActive == "active" ? "justify-content-centered" : ""
            }`}
          >
            <img src={accessments} alt="accessments" />
            <p className={`m-0 ${props.isActive == "active" ? "d-hide" : ""}`}>
              Assessments
            </p>
          </Link>
        </li>
        <li className={props.page === "administrative-controls" ? "active" : ""}>
          <Link
            to="/administrative-controls"
            className={`${
              props.isActive == "active" ? "justify-content-centered" : ""
            }`}
          >
            <img src={controls} alt="administrative-controls" />
            <p className={`m-0 ${props.isActive == "active" ? "d-hide" : ""}`}>
              Administrative Controls
            </p>
          </Link>
        </li> */}
        <li className={props.page === "howtouse" ? "active" : ""}>
          <Link to="/how-to-use" className={`${props.isActive == "active" ? "justify-content-centered" : ""}`}>
            <img src={tap} alt="how to use" />
            <p className={`m-0 ${props.isActive == "active" ? "d-hide" : ""}`}>How to use</p>
          </Link>
        </li>
        <li className={props.page === "contact" ? "active" : ""}>
          <Link to="/contact-us" className={`${props.isActive == "active" ? "justify-content-centered" : ""}`}>
            <img src={contact} alt="contact" />
            <p className={`m-0 ${props.isActive == "active" ? "d-hide" : ""}`}>Contact us</p>
          </Link>
        </li>
        <div className="border-line my-2"></div>
        <li>
          <span className={`${props.isActive == "active" ? "justify-content-centered" : ""}`} onClick={handleLogout}>
            <img src={logOut} alt="logOut" />
            <p className={`m-0 ${props.isActive == "active" ? "d-hide" : ""}`}>Logout</p>
          </span>
        </li>
      </div>
    </div>
  );
};

export default Sidebar;